<template>
    <div
        class="m-product m-product--offer"
        :draggable="draggable"
        @dragstart="startDrag($event)"
    >
        <div
            v-if="draggable"
            class="m-product__drag"
        ></div>
        <div
            v-if="draggable"
            class="m-product__close"
            @click="remove()"
        ></div>
        <figure class="m-product__image">
            <img
                v-if="product.image_url"
                :src="`${apiUrl}${product.image_url}`"
                alt=""
                class="m-product__imageImg"
            >
            <img
                v-else
                src="@/assets/pack.jpg"
                alt=""
                class="m-product__imageImg"
            >
        </figure>
        <div>
            <p class="m-product__title">
                <span
                    v-if="product.desc_html"
                    class="a-tooltip__icon"
                >
                    <svg width="12" height="12" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)" fill="#fff"><path d="M0 6.614c.207-.394.276-.772.483-.854 1.103-.443 2.224-.886 3.465-.64 1.259.247 1.914 1.018 1.724 2.216-.19 1.149-.551 2.265-.827 3.397-.12.509-.293 1.001-.38 1.51-.19 1.132.294 1.559 1.5 1.362.225-.033.449-.082.673-.115.069.05.12.115.19.164-.259.263-.466.624-.776.772-.983.443-2.018.755-3.138.508-1.259-.279-1.948-1.017-1.759-2.215.207-1.28.604-2.527.931-3.791.104-.443.242-.903.293-1.346.087-.935-.362-1.296-1.345-1.149-.275.033-.551.082-1.034.18zM5.172 0C6.26.05 7.07.87 7 1.855c-.069.968-.966 1.657-2.069 1.608-1.034-.05-1.862-.837-1.845-1.773C3.121.706 4.052-.05 5.172 0z"></path></g><defs><clipPath id="clip0"><path d="M0 0h7v15H0V0z" fill="#fff"></path></clipPath></defs></svg>
                </span>
                <span
                    v-if="product.desc_html"
                    class="a-tooltip__popup"
                    v-html="product.desc_html"
                ></span>
                {{ product.name }}
            </p>
            <div class="m-product__data">
                <p
                    v-if="packagePrice"
                    class="m-product__price"
                >
                    {{ packagePrice.toPLN() }}
                </p>
                <p class="a-label"><br />{{ cycle }}</p>
                <p
                    v-if="amount"
                    class="m-product__amount a-label"
                >
                    {{ amount }} szt.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        dayInWeek: {
            type: Number,
            required: true
        },
        addressId: {
            type: Number,
            default: 0
        },
        showInModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        startDrag(evt) {
            if(this.draggable) {
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('productId', this.product.id)
                evt.dataTransfer.setData('orderId', this.weekOrderId)
                evt.dataTransfer.setData('cycleId', this.cycleId)
                this.$store.dispatch('setDragStatus', true)
                this.$store.dispatch('setDragProductId', this.product.id)
                this.$store.dispatch('setDragPackageDayInWeek', this.dayInWeek)
            }
        },
        remove() {
            // add product to features
            const featuredPackages = Array.from(this.featuredPackages)
            featuredPackages.push(this.product)
            this.$store.dispatch('setOfferFeaturedPackages', featuredPackages)
            // remove from day order
            this.$store.dispatch('applyProductToCart', {
                dayInWeek: this.dayInWeek,
                addressId: this.addressId,
                product: this.product,
                amount: 0
            })
        }
    },
    computed: {
        apiUrl() {
            return `${process.env.VUE_APP_API}b2b/v1`
        },
        amount() {
            return this.weekDayOrder ? this.weekDayOrder.amount : 0
        },
        cycle() {
            return this.weekDayOrder ? this.weekDayOrder.cycle : 0
        },
        cycleId() {
            return this.weekDayOrder ? this.weekDayOrder.cycleId : null
        },
        weekDayOrder() {
            return this.$store.getters.weekDayOrder(this.dayInWeek, this.addressId).find(item => item.product.id === this.product.id)
        },
        packagePrice() {
            return this.weekDayOrder ? this.weekDayOrder.net_price : 0
        },
        weekOrderId() {
            return this.$store.getters.weekOrders.findIndex(item => item.addressId === this.addressId && item.dayInWeek === this.dayInWeek && item.product.id === this.product.id)
        },
        draggable() {
            return !!this.weekDayOrder.draggable
        },
        featuredPackages() {
            return this.$store.getters.offerFeaturedPackages
        }
    }
}
</script>
